import axios from './providers/axios';

const depService = {
    getCompanyDeps(page, company, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&companyId=${company}`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/department/store?${queryParams}`);
    },
    getDeps(companyId) {
        return axios.get(`/v1/admin/department/store?companyId=${companyId}`);
    },
    getDepList() {
        return axios.get(`/v1/admin/department/store?list=1`);
    },
    getDep(id) {
        return axios.get(`/v1/admin/department/getFromId?departmentId=${id}`);
    },
    addDep(data) {
        return axios.post(`/v1/admin/department/add`, data);
    },
    updateDep(data) {
        return axios.put(`/v1/admin/department/update`, data);
    },
    deleteDep(depId) {
        return axios.delete(`/v1/admin/department/delete/${depId}`);
    },

    getAssignedItems(departmentId, type) {
        return axios.get(`/v1/admin/department/getAssigned`, {
            params: {
                departmentId: departmentId,
                type: type // 'program', 'test', 'gameLabs'
            }
        });
    }
}

export default depService;
